export const languages = [
  { text: '中文-简体', type: 'zh_CN' },
  { text: '中文-繁體', type: 'zh_TW' },
  { text: 'English', type: 'en_US' },
  { text: '日本語', type: 'ja_JP' },
  { text: '한국어', type: 'ko_KR' },
];

export function savedLanguage() {
  try {
    const saved = JSON.parse(localStorage.getItem('language') || 'null');
    return languages.find(item => item.type === saved?.type) || null;
  } catch (_) { return null; }
}
